import React from 'react';
import Autocomplete from '../common/AutoComplete';
import DepartmentAutocomplete from '../common/DepartmentAutocomplete';
import NamedAutocomplete from '../common/NamedAutocomplete';
import { useSelector, useDispatch } from 'react-redux';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useRef, useEffect, useState } from 'react';
import useAuth from '../../hooks/useAuth';
import store from '../../store';
import { useNavigate,Link,Location, useLocation } from 'react-router-dom';


function PaymentRequestForm() {

	const autocompleteElement = useRef('');
	const locationAutocompleteElement = useRef('');

	//React.createRef();
	const REQUEST_URL="/PaymentApproval/AddPaymentRequest"
	const VENDOR_REQUEST_URL="/PaymentApproval/GetVendors";
	const LOCATION_REQUEST_URL="/Inventory/GetLocations";		
	const {auth,setAuth} = useAuth();
	const axiosPrivate = useAxiosPrivate();
	const errRef = useRef();
	const [errMsg, setErrMsg] = useState('');

	const inventoryRequestState = useSelector((state)=> state.value);
	
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const arrSuggestionsRedux = useSelector(() => store.getState().orderitem.SpareItems);

	//let arrSuggestions = [];
	const [arrSuggestions, setSuggestions] = useState([]);
	const [arrLocation, setLocation] = useState([]);

	//useEffect(()=>{userRef.current.focus()},[]);
    
	useEffect(() => {

		try{
            //console.log(`Bearer ${auth.accessToken}`)
            const response = axiosPrivate.get(VENDOR_REQUEST_URL,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
				
				//console.log(response.data);
                setSuggestions(response.data);
				dispatch({ type: 'addVendor', payload: {
					...state,
					'vendors': response.data
				  }})
              })
              .catch(error =>{
                console.log(error);
              });

			const locationResponse = axiosPrivate.get(LOCATION_REQUEST_URL,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
				
				//console.log(response.data);
                setLocation(response.data);
				dispatch({ type: 'addLocations', payload: {
					...state,
					'locations': response.data
				  }})

              })
              .catch(error =>{
                console.log(error);
              });
        }
        catch(err){

            console.log(err.response);

        }
		
	  }, []);

	const [state, setState] = React.useState({
		//id: 0,
		vendor: null,
		invoiceNo: "",
		grossAmount:"",
		tds:"",
		advance:"",
		hold:"",		
		netPayable:"",
		remark:"",
		location: null,
	});

	useEffect(()=>{
		setErrMsg('');
		setState({
			...state,
			netPayable: state.grossAmount - state.tds - state.advance - state.hold
		  });
	},[state.vendor,state.grossAmount,state.tds,state.advance,state.hold,state.remark,state.location]);

	function handleChange(evt) {
	
	let value = evt.target.value;
	
	setState({
		...state,
		[evt.target.name]: value
	});
	};

	function clear()
	{

		setState({
			vendor: null,
			invoiceNo:"",
			grossAmount:"",
			tds:"",
			advance:"",
			hold:"",		
			netPayable:"",
			remark:"",
			location: "",
		  });
		
		autocompleteElement.current.resetState();
		locationAutocompleteElement.current.resetState();
	};

	function updateVendorSelection(vendorItem)
	{
		console.log(`Vendor Value : ${vendorItem}`)
		setState({
			...state,
			vendor: vendorItem,	
		  })
	}

	function updateLocationSelection(locationItem)
	{
		// console.log(`Location Value : ${locationItem}`)
		setState({
			...state,
			location: locationItem.name,	
		  })
	}	

	const onClearClick = (event) =>{
		clear();
	};

	function search(nameKey, myArray){
		for (let i=0; i < myArray.length; i++) {
			if (myArray[i].name === nameKey) {
				return myArray[i];
			}
		}
	}

	const onAddClick = async(event) => {

		try{

			if(!state.vendor || !state.invoiceNo || !state.grossAmount || !state.tds || !state.advance || !state.hold || !state.netPayable || !state.remark || !state.location)
			{
				setErrMsg('Please input mandatory fields');
				return false;
			}

			console.log(`Location Value : ${state.vendor}`)
			console.log(`Location Value : ${state.invoiceNo}`)
			console.log(`Location Value : ${state.grossAmount}`)
			console.log(`Location Value : ${state.tds}`)
			console.log(`Location Value : ${state.advance}`)
			console.log(`Location Value : ${state.hold}`)
			console.log(`Location Value : ${state.netPayable}`)
			console.log(`Location Value : ${state.remark}`)
			console.log(`Location Value : ${state.location}`)

			if(state.grossAmount < 1)
			{
				setErrMsg('Gross Amount cannot be less than 1');
				return false;
			} else if(state.tds < 0)
			{
				setErrMsg('TDS cannot be less than 0');
				return false;
			} else if(state.advance < 0)
			{
				setErrMsg('Advance cannot be less than 0');
				return false;
			} else if(state.hold < 0)
			{
				setErrMsg('Hold cannot be less than 0');
				return false;
			} else if(state.netPayable < 1)
			{
				setErrMsg('Net Payable cannot be less than 1');
				return false;
			} 

			setState({
				...state,
				'vendor.name': String(state.vendor.name).replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
			});

			dispatch({ type: 'addpaymentrequest', payload: {
				...state,
			}})
			
			clear();
			const requestPaylod = {
                vendorId: state.vendor.id,
				invoiceNo: state.invoiceNo,
				grossAmount: Number(state.grossAmount),
				tds: Number(state.tds),
				advance: Number(state.advance),
				hold: Number(state.hold),		
				netPayable: Number(state.netPayable),
				remarks: state.remark,
				location: state.location,
			}

            const response = await axiosPrivate.post(REQUEST_URL,requestPaylod,{
                withCredentials: true,
                headers: {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${auth?.accessToken}`
                  //'access-control-allow-origin' : '*'
                }
              })
              .then(response =>{
                navigate("/paymenthistory");
              })
              .catch(error =>{
                console.log(error);
              });
          
        }
        catch(err){

            console.log(err.response);

        }
		
	  };


  return (
    <><form>
		<div className="mb-3 row">
        <p ref={errRef} style={{display: errMsg ? 'block' : 'none'}} className={errMsg?'validation':"offscreen"} aria-live='assertive'>{errMsg}</p>
        </div>
		  <div className="mb-3 row">
			  <label className="col-sm-2 col-form-label">Vendor *</label>
			  <div className="col-sm-3">
				   <Autocomplete
						suggestions={arrSuggestions} ref={autocompleteElement} change={updateVendorSelection}
					/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputInvoiceNo" className="col-sm-2 col-form-label">Invoice No *</label>
			  <div className="col-sm-3">
				  <input type="text" name="invoiceNo" className="form-control" onChange={handleChange} placeholder='Enter Invoice No' value={state.invoiceNo} id="inputInvoiceNo" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputGrossAmount" className="col-sm-2 col-form-label">Gross Amount *</label>
			  <div className="col-sm-3">
				  <input type="number" min="0" name="grossAmount" className="form-control" onChange={handleChange} placeholder='Enter Gross Amount' value={state.grossAmount} id="inputGrossAmount" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputTDS" className="col-sm-2 col-form-label">TDS *</label>
			  <div className="col-sm-3">
				  <input type="number" min="0" name="tds" className="form-control" onChange={handleChange} placeholder='Enter TDS' value={state.tds} id="inputTDS" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputAdvance" className="col-sm-2 col-form-label">Advance *</label>
			  <div className="col-sm-3">
				  <input type="number" min="0" name="advance" className="form-control" onChange={handleChange} placeholder='Enter Advance' value={state.advance} id="inputAdvance" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputHold" className="col-sm-2 col-form-label">Hold *</label>
			  <div className="col-sm-3">
				  <input type="number"  min="0"name="hold" className="form-control" onChange={handleChange} placeholder='Enter Hold' value={state.hold} id="inputHold" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputNetPayable" className="col-sm-2 col-form-label">Net Payable *</label>
			  <div className="col-sm-3">
				  <input type="number" name="netPayable" className="form-control" value={state.netPayable} id="inputNetPayable" readOnly disabled/>
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputRemark" className="col-sm-2 col-form-label">Remark *</label>
			  <div className="col-sm-3">
				  <input type="text" name="remark" className="form-control" onChange={handleChange} placeholder='Enter Remark' value={state.remark} id="inputRemark" />
			  </div>
		  </div>
		  <div className="mb-3 row">
			  <label htmlFor="inputLocation" className="col-sm-2 col-form-label">Location *</label>
			  <div className="col-sm-3">
			  		<NamedAutocomplete
						suggestions={arrLocation} ref={locationAutocompleteElement} change={updateLocationSelection}
					/>
				  {/* <input type="text" name="purpose" className="form-control" onChange={handleChange} value={state.purpose} id="inputPurpose" /> */}
			  </div>
		  </div>
		  <div className="mb-3 row">

			  <div className="col-sm-4">
				  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
					  <button className="btn btn-warning me-md-2" onClick={onClearClick} type="button">Clear</button>
					  <button className="btn btn-primary" type="button" onClick={onAddClick}>Add</button>
				  </div>
			  </div>
		  </div>

	  </form>
	  
	  </>
  )
}

export default PaymentRequestForm